"use strict";

class PropertySettingsController {

    constructor($sce, $scope, $parse, $window, $timeout, $localStorage, SSHttpService, SSUtilService, SSConfigService, SSAppService, SSAlertService, OTPService, NgTableParams, SSConfirmationService, SSUserService, Upload) {
        const self = this;

        self.$sce = $sce;
        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;
        self.$window = $window;
        self.$localStorage = $localStorage;

        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.NgTableParams = NgTableParams;
        self.SSConfirmationService = SSConfirmationService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;
        self.EDITOR_API_KEY = SHOWSUITE.data.EDITOR_API_KEY;

        // WEB-3631: project-level document-numbering override (Invoice / Receipt / Credit Note)
        self.DEVELOPER_SETTINGS_PAYMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_PAYMENT_TRACKING_NUMBER;
        self.DEVELOPER_SETTINGS_INSTRUMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_INSTRUMENT_TRACKING_NUMBER;
        self.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER;

        //Document Kinds
        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;
        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
        self.PROPERTY_DOCUMENT_KIND_PDI_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SIDE_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ANNEXES = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_A = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_B3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_C;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_AML = SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML;
        self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION;
        self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM;
        self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE;
        self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_B;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_C;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_D;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_E;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_G;
        self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION;


        self.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_TEAM_IC = SHOWSUITE.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_TEAM_IC;
        self.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_TEAM_IC_CORE = SHOWSUITE.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_TEAM_IC_CORE;
        self.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_AGENTS = SHOWSUITE.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_AGENTS;
        self.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_NONE = SHOWSUITE.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_NONE;

        self.PROPERTY_SETTINGS_LONGER_UNIT_RESERVATION_NOTIFICATION = SHOWSUITE.PROPERTY_SETTINGS_LONGER_UNIT_RESERVATION_NOTIFICATION;
        self.PROPERTY_SETTINGS_REMOTE_SIGNING_REVERT = SHOWSUITE.PROPERTY_SETTINGS_REMOTE_SIGNING_REVERT;
        self.PROPERTY_SETTINGS_TEAM_IC_COUNTER_BOOKING = SHOWSUITE.PROPERTY_SETTINGS_TEAM_IC_COUNTER_BOOKING;

        self.PROPERTY_SETTINGS_CORPORATE_PURCHASE_MULTIPLE_SIGNATORIES_SUPPORT = SHOWSUITE.PROPERTY_SETTINGS_CORPORATE_PURCHASE_MULTIPLE_SIGNATORIES_SUPPORT;
        self.PROPERTY_SETTINGS_TRUE_PURCHASER_MULTIPLE_SIGNATORIES_SUPPORT = SHOWSUITE.PROPERTY_SETTINGS_TRUE_PURCHASER_MULTIPLE_SIGNATORIES_SUPPORT;
        self.PROPERTY_SETTINGS_SEND_STATUS_AND_PRICE_UPDATES_TO_EXTERNAL_CLIENT = SHOWSUITE.PROPERTY_SETTINGS_SEND_STATUS_AND_PRICE_UPDATES_TO_EXTERNAL_CLIENT;
        self.PROPERTY_SETTINGS_ALLOW_UNIT_ALLOCATION_FOR_SUBMITTED_EOIS = SHOWSUITE.PROPERTY_SETTINGS_ALLOW_UNIT_ALLOCATION_FOR_SUBMITTED_EOIS;
        self.PROPERTY_SETTINGS_ENABLE_SINGAPORE_NRIC_VALIDATION = SHOWSUITE.PROPERTY_SETTINGS_ENABLE_SINGAPORE_NRIC_VALIDATION;

        self.PROPERTY_SETTINGS_ENABLE_SHOWCASE = SHOWSUITE.PROPERTY_SETTINGS_ENABLE_SHOWCASE;
        self.PROPERTY_SETTINGS_ENABLE_SHOWCASE_ANALYTICS = SHOWSUITE.PROPERTY_SETTINGS_ENABLE_SHOWCASE_ANALYTICS;

        self.PROPERTY_SETTINGS_TOP_MAINTENANCE_AND_SURVEY_FEE = SHOWSUITE.PROPERTY_SETTINGS_TOP_MAINTENANCE_AND_SURVEY_FEE;

        self.AVAILABILITY_PUBLIC = SHOWSUITE.AVAILABILITY_PUBLIC;
        self.AVAILABILITY_BROKERS_ALL = SHOWSUITE.AVAILABILITY_BROKERS_ALL;
        self.AVAILABILITY_BROKERS_TEAM = SHOWSUITE.AVAILABILITY_BROKERS_TEAM;
        self.AVAILABILITY_TEAM_LEADS = SHOWSUITE.AVAILABILITY_TEAM_LEADS;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;
        self.DISCOUNT_TYPE_STANDARD = SHOWSUITE.DISCOUNT_TYPE_STANDARD;

        self.INSTRUMENT_TYPE_NO_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_NO_CHEQUE;
        self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;
        self.INSTRUMENT_TYPE_CASHIERS_ORDER = SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER;
        self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER;
        self.INSTRUMENT_TYPE_CASH_IN = SHOWSUITE.INSTRUMENT_TYPE_CASH_IN;
        self.INSTRUMENT_TYPE_GIRO = SHOWSUITE.INSTRUMENT_TYPE_GIRO;
        self.INSTRUMENT_TYPE_DEBIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD;
        self.INSTRUMENT_TYPE_FAST_CASH = SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH;
        self.INSTRUMENT_TYPE_BANK_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_BANK_TRANSFER;
        self.INSTRUMENT_TYPE_PAYNOW_OTHERS = SHOWSUITE.INSTRUMENT_TYPE_PAYNOW_OTHERS;
        self.INSTRUMENT_TYPE_CREDIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_CREDIT_CARD;
        self.INSTRUMENT_TYPE_CASH = SHOWSUITE.INSTRUMENT_TYPE_CASH;
        self.INSTRUMENT_TYPE_EDP = SHOWSUITE.INSTRUMENT_TYPE_EDP;
        self.INSTRUMENT_TYPE_EDP_PLUS = SHOWSUITE.INSTRUMENT_TYPE_EDP_PLUS;

        self.PROPERTY_STATUS_DEV_CHANGE_MAP = {};
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_DRAFT] = self.PROPERTY_STATUS_REVIEW;
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_REJECTED] = self.PROPERTY_STATUS_REVIEW;
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_APPROVED] = self.PROPERTY_STATUS_LISTED;
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_LISTED] = self.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_ARCHIVED] = self.PROPERTY_STATUS_ARCHIVED;

        self.PROPERTY_STATUS_CHANGE_MAP_TEXT = {};
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_DRAFT] = 'Submit For Review';
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_REJECTED] = 'Re-Submit For Review';
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_APPROVED] = 'Publish';
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_LISTED] = 'Un-Publish';
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_ARCHIVED] = 'Archived';
        // Property Status

        self.PAYMENT_PLAN_TYPE_NPS = SHOWSUITE.PAYMENT_PLAN_TYPE_NPS;
        self.PAYMENT_PLAN_TYPE_DPS = SHOWSUITE.PAYMENT_PLAN_TYPE_DPS;
        self.PAYMENT_PLAN_TYPE_PVT = SHOWSUITE.PAYMENT_PLAN_TYPE_PVT;
        self.PAYMENT_PLAN_TYPE_ALL = SHOWSUITE.PAYMENT_PLAN_TYPE_ALL;

        // https://showsuite.atlassian.net/browse/WEB-2743
        // self.PROPERTY_SETTINGS_EMAIL_ROBOT_SPA_DATE_UPDATE = SHOWSUITE.PROPERTY_SETTINGS_EMAIL_ROBOT_SPA_DATE_UPDATE;
        // self.PROPERTY_SETTINGS_EMAIL_ROBOT_SALE_CREATE = SHOWSUITE.PROPERTY_SETTINGS_EMAIL_ROBOT_SALE_CREATE;
        // self.PROPERTY_SETTINGS_EMAIL_ROBOT_SALE_UPDATE = SHOWSUITE.PROPERTY_SETTINGS_EMAIL_ROBOT_SALE_UPDATE;

        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;

        self.EMAIL_TEMPLATE_SETTINGS_OTP_GENERATED = SHOWSUITE.EMAIL_TEMPLATE_SETTINGS_OTP_GENERATED;
        self.EMAIL_TEMPLATE_SETTINGS_OTP_RE_GENERATED = SHOWSUITE.EMAIL_TEMPLATE_SETTINGS_OTP_RE_GENERATED;
        self.EMAIL_TEMPLATE_SETTINGS_SPA_DATE_UPDATED = SHOWSUITE.EMAIL_TEMPLATE_SETTINGS_SPA_DATE_UPDATED;
        self.EMAIL_TEMPLATE_EOI_SUBMITTED = SHOWSUITE.EMAIL_TEMPLATE_EOI_SUBMITTED;
        self.EMAIL_TEMPLATE_SETTING_SALE_ABORT = SHOWSUITE.EMAIL_TEMPLATE_SETTING_SALE_ABORT;
        self.EMAIL_TEMPLATE_SETTING_ON_ADD_PAYMENT = SHOWSUITE.EMAIL_TEMPLATE_SETTING_ON_ADD_PAYMENT;
        self.EMAIL_TEMPLATE_SETTING_ON_ADD_PAYMENT_INSTRUMENT = SHOWSUITE.EMAIL_TEMPLATE_SETTING_ON_ADD_PAYMENT_INSTRUMENT;

        self.payment_types = [
            {id: -1, name: "Disabled", allowed: false},
            {id: self.INSTRUMENT_TYPE_CHEQUE, name: "Bank Cheque", allowed: false},
            {id: self.INSTRUMENT_TYPE_CASHIERS_ORDER, name: "Cashier's Order", allowed: false},
            {id: self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER, name: "Telegraphic Transfer (TT)", allowed: false},
            {id: self.INSTRUMENT_TYPE_CASH_IN, name: "Cash-In", allowed: false},
            {id: self.INSTRUMENT_TYPE_GIRO, name: "GIRO", allowed: false},
            {id: self.INSTRUMENT_TYPE_DEBIT_CARD, name: "Debit Card", allowed: false},
            {id: self.INSTRUMENT_TYPE_FAST_CASH, name: "Fast Cash", allowed: false},
            {id: self.INSTRUMENT_TYPE_BANK_TRANSFER, name: "Bank Transfer", allowed: false},
            {id: self.INSTRUMENT_TYPE_PAYNOW_OTHERS, name: "PayNow Others", allowed: false},
            {id: self.INSTRUMENT_TYPE_EDP, name: "EDP", allowed: false},
            {id: self.INSTRUMENT_TYPE_EDP_PLUS, name: "EDP+", allowed: false},
            {id: self.INSTRUMENT_TYPE_CREDIT_CARD, name: "Credit Card", allowed: false},
            {id: self.INSTRUMENT_TYPE_CASH, name: "Cash", allowed: false},
        ];

        self.payment_types_eoi = [
            {id: -1, name: "Disabled", allowed: false},
            {id: self.INSTRUMENT_TYPE_NO_CHEQUE, name: "No Cheque", allowed: false},
            {id: self.INSTRUMENT_TYPE_CHEQUE, name: "Bank Cheque", allowed: false},
            {id: self.INSTRUMENT_TYPE_CASHIERS_ORDER, name: "Cashier's Order", allowed: false},
            {id: self.INSTRUMENT_TYPE_EDP, name: "EDP", allowed: false},
            {id: self.INSTRUMENT_TYPE_EDP_PLUS, name: "EDP+", allowed: false},
        ];

        self.user = self.SSUserService.getUser();
        self.law_firms = self.SSConfigService.getLawFirms();
        self.law_firms.push({'code': '999999', 'name': 'OTHERS'});

        self.formSettingTab = 'EOI';

        self.topSettingsEditMode = false;

        // WEB-3631: editable buffers / loaded state for the project-level numbering overrides.
        self.trackingNumberSettings = {
            payment_tracking_no: {},
            instrument_tracking_no: {},
            refund_payment_tracking_no: {},
        };
        self.trackingForm = {
            payment_tracking_no: {override: false, value: {}},
            instrument_tracking_no: {override: false, value: {}},
            refund_payment_tracking_no: {override: false, value: {}},
        };
        self.trackingEditMode = {
            payment_tracking_no: false,
            instrument_tracking_no: false,
            refund_payment_tracking_no: false,
        };
        self.trackingError = {};

        if (self.SSUserService.isDeveloper() && self.data.property) {
            self.init();
        }

        self.ppFormSettingKeys = [
            'individual',
            'company',
            'signatory',
            'key_personnel',
            'legal_entity',
            'address'
        ]

        /**
         * WEB-3540: property_settings blobs that are genuine MAPS (dot-accessed in the Blade),
         * are OVERWRITTEN by JSON.parse(stored value) on load, and saved via raw JSON.stringify.
         * These can flip to [] (legacy / external writers) and silently drop dot-assigned keys.
         * normalizeMapPropertySettings() coerces any of these that loaded as an array back to {}.
         * Excludes: aml (rebuilt on save), payment_types* / default_sale_email_document_kinds
         * (arrays / rebuilt), pp_form_required_fields* and buyer_identity_documents_disabled
         * (maps but mutated in place, never overwritten), and all scalar settings.
         */
        self.MAP_PROPERTY_SETTING_NAMES = [
            'longer_unit_reservation_notification',
            'remote_signing_revert_settings',
            'team_ic_counter_booking_settings',
            'corporate_purchase_multiple_signatories_support',
            'true_purchaser_multiple_signatories_support',
            'send_status_and_price_updates_to_external_client',
            'enable_showcase',
            'enable_showcase_analytics',
            'skip_team_ic_booking_verification',
            'skip_developer_sale_verification',
            'enquiry_email',
            'non_buyer_payee_settings',
            'witness_settings',
            'power_of_attorney_settings',
            'other_beneficiary_owner_settings',
            'true_purchaser_settings',
            'sale_otp_representative_settings',
            'other_aml_cft_settings',
            'gst_setting',
            'unit_price_gst_inclusive',
            'different_otp_for_commercial_units',
            'top_maintenance_and_survey_fee',
            'allow_unit_allocation_for_submitted_eois',
            'enable_singapore_nric_validation',
            'billing_date_follows_notice_served_date'
        ];

        /**
         * WEB-4250: see getPropertySettings(), which repopulates this from the server response.
         * Defaulted here too because that method returns early when there is no property, and the
         * save path must never dereference an undefined snapshot.
         *
         * @type {Object.<string, string>}
         */
        self.storedSettingValues = {};
    }

    init() {
        const self = this;

        self.initEmailTemplateConstants();

        self.editor = null;
        self.selectedItem = 'buyer';

        self.getPropertySettings();
        self.getEmailSettings();
        self.getDeveloper();
        self.getTrackingNumberSettings();
    }

    //get the project settings
    getPropertySettings() {
        const self = this;

        if (!self.data.property.id)
            return;

        self.settings = null;
        /**
         * WEB-4250: the property_settings rows exactly as the server returned them, keyed by name.
         * savePropertySettings() uses this to tell "the user just cleared this field" apart from
         * "this field was already empty", which is the difference between a deliberate delete and
         * destroying an untouched row. Names with no stored row are simply absent.
         *
         * @type {Object.<string, string>}
         */
        self.storedSettingValues = {};
        self.aml_cft_checkbox = false;
        self.arms_email_checkbox = false;
        // self.otp_for_commercial_units_checkbox = false;
        self.psettings = {
            "aml": {
                risk_assessment_required: false,
            },
            "aml_cft": '',
            "arms_email": '',
            "longer_unit_reservation_notification": {
                "enabled": false,
                "reservation_duration": 0,
                "target_emails": ""
            },
            "remote_signing_revert_settings": {
                "enabled": true, // Default to true
                "revert_after_days": 14, // Default to 2 weeks
            },
            "team_ic_counter_booking_settings": {
                "enabled": 0,
            },
            "skip_team_ic_booking_verification": {
                "enabled": 0,
            },
            "skip_developer_sale_verification": {
                "enabled": 0,
            },
            "enquiry_email": {
                "enable": false,
                "emails": ""
            },
            "buying_in_trust_setting": 0,
            "min_age_to_purchase": 0,
            "different_otp_for_commercial_units": {
                "enable": false,
                "prefix": "",
                "postfix": ""
            },
            // WEB-3614 — project-level toggle for the Subsale Draft → Approved flow (default OFF)
            "subsale_approval_flow": {
                "enable": false
            },
            // WEB-3908 / WEB-3906 — lock the payment Billing Date (payments.due_date) to the
            // Notice Served Date (payments.serving_date). Default OFF; the server fails closed
            // on an absent / blank / malformed row, so this default must mirror that.
            "billing_date_follows_notice_served_date": {
                "enabled": 0
            },
            "otp_spa": "OTP",
            "buyer_sale_documents_link_expiry_days": 0,
            "document_signing_method": "signature_pad",
            "pp_form_required_fields": self.SSConfigService.getPPFormRequiredFields(),
            "pp_form_required_fields_eoi": self.SSConfigService.getEOIFormRequiredFields(),
            "pp_form_required_fields_witness": self.SSConfigService.getWitnessFormRequiredFields(),
            'pp_form_required_fields_non_buyer_payee': self.SSConfigService.getNonBuyerPayeeFormRequiredFields(),
            'pp_form_required_fields_power_of_attorney': self.SSConfigService.getPowerOfAttorneyRequiredFields(),
            'pp_form_required_fields_other_beneficiary_owner': self.SSConfigService.getOtherBeneficiaryOwnerRequiredFields(),
            'pp_form_required_fields_true_purchaser': self.SSConfigService.getTruePurchaserRequiredFields(),
            'pp_form_required_fields_beneficiary': self.SSConfigService.getBeneficiaryOwnerRequiredFields(),
            "payment_types": angular.copy(self.payment_types),
            "payment_types_eoi": angular.copy(self.payment_types_eoi),
            "payment_types_dms": angular.copy(self.payment_types),
            "non_buyer_payee_settings": {
                "enable": 0,
            },
            "witness_settings": {
                "enable": 0,
            },
            "power_of_attorney_settings": {
                "enable": 0,
            },
            "other_beneficiary_owner_settings": {
                "enable": 0,
            },
            "true_purchaser_settings": {
                "enable": 0,
            },
            "sale_otp_representative_settings": {
                "enable": 1,
            },
            "other_aml_cft_settings": {
                "enable": 0,
            },
            "unit_price_gst_inclusive": {
                "enable": null,
            },
            "buyer_identity_documents_disabled": {
                "buyers":0,
                "buyer_individual_eoi": 0,
                "buyer_company_eoi": 0,
                "buyer_signatory_eoi": 0,
                "buyer_key_personnel_eoi": 0,
                "buyer_individual_booking": 0,
                "buyer_company_booking": 0,
                "buyer_signatory_booking": 0,
                "buyer_key_personnel_booking": 0,
                "beneficiaries": 0,
                "non_buyers_payees": 0,
                "non_buyers_payees_individual": 0,
                "non_buyers_payees_company": 0,
                "non_buyers_payees_signatory": 0,
                "non_buyers_payees_key_personnel": 0,
                "witnesses": 1,
                "power_of_attorney": 0,
                "other_beneficiary_owner": 0,
                "true_purchaser": 0,
                "true_purchaser_individual": 0,
                "true_purchaser_company": 0,
                "true_purchaser_signatory": 0,
                "true_purchaser_key_personnel": 0,
                "true_purchaser_legal_entity": 0,
                "others": 0,
            },
            "corporate_purchase_multiple_signatories_support": {
                "enabled": 0,
            },
            "true_purchaser_multiple_signatories_support": {
                "enabled": 0,
            },
        };

        let url = 'sec/developer/properties/' + self.data.property.id + '/settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //self.settings=self.SSHttpService.parseErrors(response);

            self.settings = response.data;

            self.storedSettingValues = {};

            jQuery.each(self.settings.property_settings, function (index, setting) {

                // WEB-4250: remember the value as stored, before the branches below parse it into
                // the shape the form binds to.
                self.storedSettingValues[setting.name] = setting.value;

                if (setting.name == "buyer_sale_documents_link_expiry_days") {
                    self.psettings.buyer_sale_documents_link_expiry_days = parseInt(setting.value);
                }
                if (setting.name == "document_signing_method") {
                    self.psettings.document_signing_method = setting.value;
                }
                if (setting.name == "stack_view_visibility") {
                    self.psettings.stack_view_visibility = setting.value;
                }
                if (setting.name == "price_visibility") {
                    self.psettings.price_visibility = setting.value;
                }
                if (setting.name == "hide_sold_unit_list_price_for_broker") {
                    self.psettings.hide_sold_unit_list_price_for_broker = setting.value;
                }
                if (setting.name == "unit_statistics") {
                    self.psettings.unit_statistics = setting.value;
                }
                if (setting.name == "unit_statistics_circle") {
                    self.psettings.unit_statistics_circle = setting.value;
                }
                if (setting.name == "booking_agent") {
                    self.psettings.booking_agent = setting.value;
                }
                if (setting.name == "payment_type") {
                    self.psettings.payment_type = setting.value;
                }
                if (setting.name == "otp_spa") {
                    self.psettings.otp_spa = setting.value;
                }
                if (setting.name == "otp_starting_no") {
                    self.psettings.otp_starting_no = parseInt(setting.value);
                }
                if (setting.name == "auto_send_congratulations_letter") {
                    self.psettings.auto_send_congratulations_letter = setting.value;
                }
                if (setting.name == "unit_release_control") {
                    self.psettings.unit_release_control = setting.value;
                }
                if (setting.name == "sale_statistics_visibility") {
                    self.psettings.sale_statistics_visibility = setting.value;
                }
                if (setting.name == "property_documents_download_availability") {
                    self.psettings.property_documents_download_availability = setting.value;
                }
                if (setting.name == "default_sale_email_document_kinds") {
                    self.psettings.server_default_allowed_document_kinds = setting.value;
                }
                if (setting.name == "aml_cft") {
                    self.psettings.aml_cft = setting.value;
                    if (self.psettings.aml_cft != '') {
                        self.aml_cft_checkbox = true;
                    }
                }
                if (setting.name == "aml") {
                    self.psettings.aml = JSON.parse(setting.value);
                    if (self.psettings.aml.risk_assessment_required === 1) {
                        self.psettings.aml.risk_assessment_required = true;
                    }
                }
                if (setting.name == "arms_email") {
                    self.psettings.arms_email = setting.value;
                    if (self.psettings.arms_email != '') {
                        self.arms_email_checkbox = true;
                    }
                }

                if (setting.name == self.PROPERTY_SETTINGS_LONGER_UNIT_RESERVATION_NOTIFICATION) {
                    self.psettings.longer_unit_reservation_notification = JSON.parse(setting.value);
                }

                if (setting.name == self.PROPERTY_SETTINGS_REMOTE_SIGNING_REVERT) {
                    self.psettings.remote_signing_revert_settings = JSON.parse(setting.value);
                }

                if (setting.name == self.PROPERTY_SETTINGS_TEAM_IC_COUNTER_BOOKING) {
                    self.psettings.team_ic_counter_booking_settings = JSON.parse(setting.value);
                }
                if (setting.name == self.PROPERTY_SETTINGS_CORPORATE_PURCHASE_MULTIPLE_SIGNATORIES_SUPPORT) {
                    self.psettings.corporate_purchase_multiple_signatories_support = JSON.parse(setting.value);
                }
                if (setting.name == self.PROPERTY_SETTINGS_TRUE_PURCHASER_MULTIPLE_SIGNATORIES_SUPPORT) {
                    self.psettings.true_purchaser_multiple_signatories_support = JSON.parse(setting.value);
                }

                if(setting.name == self.PROPERTY_SETTINGS_SEND_STATUS_AND_PRICE_UPDATES_TO_EXTERNAL_CLIENT){
                    self.psettings.send_status_and_price_updates_to_external_client = JSON.parse(setting.value);
                }

                if(setting.name == self.PROPERTY_SETTINGS_ENABLE_SHOWCASE){
                    self.psettings.enable_showcase = JSON.parse(setting.value);
                }

                if(setting.name == self.PROPERTY_SETTINGS_ENABLE_SHOWCASE_ANALYTICS){
                    self.psettings.enable_showcase_analytics = JSON.parse(setting.value);
                }

                if (setting.name == 'skip_team_ic_booking_verification') {
                    self.psettings.skip_team_ic_booking_verification = JSON.parse(setting.value);
                }

                if (setting.name == 'skip_developer_sale_verification') {
                    self.psettings.skip_developer_sale_verification = JSON.parse(setting.value);
                }

                if (setting.name == 'enquiry_email') {
                    self.psettings.enquiry_email = JSON.parse(setting.value);
                }
                if (setting.name == 'non_buyer_payee_settings') {
                    self.psettings.non_buyer_payee_settings = JSON.parse(setting.value);
                }
                if (setting.name == 'witness_settings') {
                    self.psettings.witness_settings = JSON.parse(setting.value);
                }
                if (setting.name == 'power_of_attorney_settings') {
                    self.psettings.power_of_attorney_settings = JSON.parse(setting.value);
                }
                if (setting.name == 'other_beneficiary_owner_settings') {
                    self.psettings.other_beneficiary_owner_settings = JSON.parse(setting.value);
                }
                if (setting.name == 'true_purchaser_settings') {
                    self.psettings.true_purchaser_settings = JSON.parse(setting.value);
                }
                if (setting.name == 'sale_otp_representative_settings') {
                    self.psettings.sale_otp_representative_settings = JSON.parse(setting.value);
                }
                if (setting.name == 'other_aml_cft_settings') {
                    self.psettings.other_aml_cft_settings = JSON.parse(setting.value);
                }
                if (setting.name == 'gst_setting') {
                    self.psettings.gst_setting = JSON.parse(setting.value);
                }
                if (setting.name == 'unit_price_gst_inclusive') {
                    self.psettings.unit_price_gst_inclusive = JSON.parse(setting.value);
                }
                if (setting.name == 'buying_in_trust_setting') {
                    self.psettings.buying_in_trust_setting = JSON.parse(setting.value);
                }
                if (setting.name == 'min_age_to_purchase') {
                    self.psettings.min_age_to_purchase = JSON.parse(setting.value);
                }
                if (setting.name == 'different_otp_for_commercial_units') {
                    self.psettings.different_otp_for_commercial_units = JSON.parse(setting.value);
                }
                // WEB-3614 — Subsale Draft → Approved flow toggle
                if (setting.name == 'subsale_approval_flow') {
                    self.psettings.subsale_approval_flow = JSON.parse(setting.value);
                }
                // WEB-3908 — Billing Date follows Notice Served Date toggle ({enabled:0|1})
                if (setting.name == 'billing_date_follows_notice_served_date') {
                    self.psettings.billing_date_follows_notice_served_date = JSON.parse(setting.value);
                }
                if (setting.name == 'pp_form_required_fields') {
                    self.updatedProcessPPFormSettings(self.psettings.pp_form_required_fields, setting);
                }
                if (setting.name == 'pp_form_required_fields_eoi') {
                    self.updatedProcessPPFormSettings(self.psettings.pp_form_required_fields_eoi, setting);
                }
                if (setting.name == 'pp_form_required_fields_non_buyer_payee') {
                    self.processPPFormSettings(self.psettings.pp_form_required_fields_non_buyer_payee, setting);
                }
                if (setting.name == 'pp_form_required_fields_power_of_attorney') {
                    self.processPPFormSettings(self.psettings.pp_form_required_fields_power_of_attorney, setting);
                }
                if (setting.name == 'pp_form_required_fields_other_beneficiary_owner') {
                    self.processPPFormSettings(self.psettings.pp_form_required_fields_other_beneficiary_owner, setting);
                }
                if (setting.name == 'pp_form_required_fields_true_purchaser') {
                    self.processPPFormSettings(self.psettings.pp_form_required_fields_true_purchaser, setting);
                }
                if (setting.name == 'pp_form_required_fields_beneficiary') {
                    self.processPPFormSettings(self.psettings.pp_form_required_fields_beneficiary, setting);
                }
                if (setting.name == 'pp_form_required_fields_witness') {
                    self.processPPFormSettings(self.psettings.pp_form_required_fields_witness, setting);
                }
                if (setting.name == 'buyer_identity_documents_disabled') {
                    self.buyerIdentityDocumentsSetting(self.psettings.buyer_identity_documents_disabled, setting)
                    // self.psettings.buyer_identity_documents_disabled = JSON.parse(setting.value);
                }
                if (setting.name == 'agent_booking_declaration') {
                    self.psettings.agent_booking_declaration = setting.value;
                }
                if (setting.name == 'payment_types') {
                    $.each(JSON.parse(setting.value), function (index, setting) {
                        self.processPaymentTypes(setting);
                    });
                }
                if (setting.name == "payment_types_eoi") {
                    $.each(JSON.parse(setting.value), function (index, setting) {
                        self.processPaymentTypesEoi(setting);
                    });
                }
                if (setting.name == "payment_types_dms") {
                    $.each(JSON.parse(setting.value), function (index, setting) {
                        self.processPaymentTypesDMS(setting);
                    });
                }
                if (setting.name == self.PROPERTY_SETTINGS_TOP_MAINTENANCE_AND_SURVEY_FEE) {
                    self.psettings.top_maintenance_and_survey_fee = JSON.parse(setting.value);
                }

                if(setting.name == self.PROPERTY_SETTINGS_ALLOW_UNIT_ALLOCATION_FOR_SUBMITTED_EOIS){
                    self.psettings.allow_unit_allocation_for_submitted_eois = JSON.parse(setting.value);
                }

                if(setting.name == self.PROPERTY_SETTINGS_ENABLE_SINGAPORE_NRIC_VALIDATION){
                    self.psettings.enable_singapore_nric_validation = JSON.parse(setting.value);
                }
                // if (setting.name == self.PROPERTY_SETTINGS_EMAIL_ROBOT_SPA_DATE_UPDATE) {
                //     self.psettings.email_robot_spa_date_update = JSON.parse(setting.value);
                // }
                // if (setting.name == self.PROPERTY_SETTINGS_EMAIL_ROBOT_SALE_CREATE) {
                //     self.psettings.email_robot_sale_create = JSON.parse(setting.value);
                // }
                // if (setting.name == self.PROPERTY_SETTINGS_EMAIL_ROBOT_SALE_UPDATE) {
                //     self.psettings.email_robot_sale_update = JSON.parse(setting.value);
                // }
            });

            /**
             * WEB-3540: coerce any genuine map property-setting that came back as [] into {} before
             * the UI binds to it. See normalizeMapPropertySettings() for the full rationale.
             */
            self.normalizeMapPropertySettings();

            self.psettings.default_sale_email_document_kinds = {};

            let document_kinds_list = [
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION, "document_name": "Letter of Authorisation"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM, "document_name": "Declaration Form"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM, "document_name": "Cover Letter Form"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_PDI_FORM, "document_name": "Pdi Form"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS, "document_name": "Buyer Particulars"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER, "document_name": "Side Letter"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_ANNEXES, "document_name": "Annexes"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_ANNEX_A, "document_name": "Annex A"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_ANNEX_B3, "document_name": "Annex B3"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_ANNEX_C, "document_name": "Annex C"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT, "document_name": "Letter of Agreement"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_OTP, "document_name": "OTP"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_AML, "document_name": "AML"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER, "document_name": "Buyer Congratulations Letter"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER, "document_name": "Selections Letter - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM, "document_name": "Elite Membership Form - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE, "document_name": "3rd Party Payor - Signable"},
                  // WEB-4691: Form 1 - Payment Declaration (for Purchaser), generated when there is no 3rd Party Payor
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT, "document_name": "Buyer Declaration For Self Payment - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT, "document_name": "External Agent Represented - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1, "document_name": "CDD Form A1 - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2, "document_name": "CDD Form A2 - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3, "document_name": "CDD Form A3 - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B, "document_name":  "CDD Form B - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C, "document_name":  "CDD Form C - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D, "document_name":  "CDD Form D - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E, "document_name":  "CDD Form E - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F, "document_name":  "CDD Form F"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2, "document_name": "CDD Form F Annexure 2"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G, "document_name": "CDD Form G - Signable"},
                  {"document_kind": self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION, "document_name": "Key Handover Collection - Signable"},
                ];

            self.fillDefaultAllowedDocumentKinds(document_kinds_list);
        });
    }

    processPPFormSettings(baseSetting, propertySettings) {
        const self = this;
        let _propertySettings = JSON.parse(propertySettings.value);

        $.each(baseSetting, function (bSKey, baseField) {
            // If base settings are marked disabled, then keep the fields same as base settings.
            // Else get the values from save project settings
            if (!baseField.mandatory) { // Means DISABLED
                $.each(_propertySettings, function (pSKey, propField) {
                    if (propField.label === baseField.label) {
                        if(propField.label === 'NRIC' || propField.label === 'Passport No.' ){
                            if(self.data.property.country === self.SSUtilService.COUNTRY_ID.AUSTRALIA){
                                if (propField.hasOwnProperty('required')) baseField.required = propField.required;
                                if (propField.hasOwnProperty('visible')) baseField.visible = propField.visible;
                            }else{
                                baseField['mandatory'] = true;
                            }
                        }else{
                            if(bSKey === pSKey){
                                if (propField.hasOwnProperty('required')) baseField.required = propField.required;
                                if (propField.hasOwnProperty('visible')) baseField.visible = propField.visible;
                            }
                        }

                        if (baseField.required) {
                            baseField.visible = true;
                        }
                    }
                });
            }
        });
    }
    updatedProcessPPFormSettings(baseSetting, propertySettings) {
        const self = this;
        let _propertySettings = JSON.parse(propertySettings.value);

        const hasSignatory = Object.keys(_propertySettings).some(key => key.startsWith('signatory_'));

        if (hasSignatory) {
            self.processPPFormSettings(baseSetting, propertySettings);
        }else{
            $.each(baseSetting, function (bSKey, baseField) {
                // If base settings are marked disabled, then keep the fields same as base settings.
                // Else get the values from save project settings
                if (!baseField.mandatory) { // Means DISABLED
                    $.each(_propertySettings, function (pSKey, propField) {
                        if (propField.label === baseField.label) {
                            if(propField.label === 'NRIC' || propField.label === 'Passport No.' ){
                                if(self.data.property.country === 36){
                                    if (propField.hasOwnProperty('required')) baseField.required = propField.required;
                                    if (propField.hasOwnProperty('visible')) baseField.visible = propField.visible;
                                }
                                else{
                                    baseField['mandatory'] = true;
                                }
                            }else{
                                if (propField.hasOwnProperty('required')) baseField.required = propField.required;
                                if (propField.hasOwnProperty('visible')) baseField.visible = propField.visible;
                            }

                            if (baseField.required) {
                                baseField.visible = true;
                            }
                        }
                    });
                }
                if(baseSetting['signatory_'+bSKey]){
                    baseSetting['signatory_'+bSKey] = baseSetting[bSKey]
                }

            });
        }
    }
    buyerIdentityDocumentsSetting(baseSetting, propertySettings){
        const self = this;
        let _propertySettings = JSON.parse(propertySettings.value);
        $.each(baseSetting, function (bSKey, value) {
            if(_propertySettings.hasOwnProperty(bSKey)){
                baseSetting[bSKey] = _propertySettings[bSKey];
            }
        });

        // TODO: REMOVE THIS AFTER BACKEND UPDATE THE OBJECT buyers TO buyer_individual_booking
        if(_propertySettings.hasOwnProperty('buyers')){
            baseSetting['buyer_individual_booking'] = _propertySettings['buyers'];
        }
    }
    getDeveloper() {
        const self = this;

        self.selectedDeveloper = null;

        let url = 'sec/developer/profile';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.selectedDeveloper = response.data.developer;
            self.getDeveloperReports();
        });
    }
    getDeveloperReports() {
        const self = this;

        self.developerReports = null;
        self.developerReportCategories = null;

        let url = 'sec/super/developer-reports';
        let params = {
            developer_id: self.selectedDeveloper.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.developerReports = response.data.developer_reports;
        });
    }
    getEmailSettings() {
        const self = this;

        if (!self.data.property.id)
            return;

        self.email_templates = [];
        self.property = self.data.property;

        let url = 'sec/developer/email-templates';

        let params = {
            property_id: self.property.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.email_templates) {
                self.email_templates = response.data.email_templates; // Set as received from server, else keep the empty array
            }

            let templates = []; // Temp array

            $.each(self.emailTemplateTypes, function (index, obj) {
                let template = self.email_templates.find(x => x.type == obj.id);
                if (template) {
                    template.name = obj.name;
                    template.is_enabled = template.is_enabled ? true : false; // Covert int to boolean
                    if (obj.recipients && obj.recipients.startsWith('::')) {
                        template.recipients = obj.recipients;
                    }
                    templates.push(template);
                } else {
                    templates.push({
                        type: obj.id,
                        name: obj.name,
                        is_enabled: false,
                        recipients: obj.recipients,
                        property_id: self.property.id,
                    });
                }
            });

            self.email_templates = templates;
        });
    }

    editEmailSettings(editMode) {
        const self = this;

        self.emailSettingsEditMode = editMode;

        if (editMode) {
            self.emailTemplateParams = self.email_templates.length ? angular.copy(self.email_templates) : [];
        }
    }

    editTopSettings(editMode){
        const self = this;
        self.topSettingsEditMode = editMode;
    }

    editTopSettings(editMode){
        const self = this;
        self.topSettingsEditMode = editMode;
    }

    editEmailTemplate(template) {
        const self = this;

        self.emailTemplate = template;
        self.contents = angular.copy(template.contents);

        // Init Froala Editor
        self.editor = new FroalaEditor('#froala-editor', {
            key: self.EDITOR_API_KEY,
            charCounterCount: false,
            placeholderText: '',

        }, function () {
        });

        $('#emailTemplateModal').modal('show');

        self.$timeout(function () {
            self.editor.html.set(self.contents);
            self.$scope.$apply();
        });
    }

    updateTemplate() {
        const self = this;

        let contents = new FroalaEditor('#froala-editor').html.get(true);
        self.emailTemplate.contents = contents;

        $('#emailTemplateModal').modal('hide');
    }

    renderHtml(contents) {
        const self = this;

        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.$sce.trustAsHtml(window.ssSanitizeHtml(contents));
    }

    isRecordUpdated(template) {
        const self = this;

        let isUpdated = false;

        if (!template) return;

        let _template = self.email_templates.find(x => x.id == template.id);

        if (_template) {
            if (template.is_enabled != _template.is_enabled)
                isUpdated = true;
            else if (template.contents != _template.contents)
                isUpdated = true;
            else if (template.recipients != _template.recipients)
                isUpdated = true;
            else if (template.subject != _template.subject)
                isUpdated = true;
            else if (template.report_id != _template.report_id)
                isUpdated = true;
        }

        template.is_updated = isUpdated;

        return isUpdated;
    }

    saveEmailSettings() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self.updated_records_index = 0;
            self.updated_templates_count = self.emailTemplateParams.filter(x => x.is_updated).length;
            $.each(self.emailTemplateParams, function (i, params) {
                if (params.is_updated) {
                    params.is_enabled = params.is_enabled ? 1 : 0;
                    self._saveEmailSettings(params);
                }
            });
        });
    }

    _saveEmailSettings(params) {
        const self = this;

        let url = 'sec/developer/email-templates';
        if(params && params.report_id === ""){
            params.report_id = null;
        }
        let handleResponse = function (response) {
            loading(false);
            self.updated_records_index++;

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (self.updated_records_index == self.updated_templates_count) {
                self.getEmailSettings();
                self.emailSettingsEditMode = false;
                self.SSAlertService.success('Success!', 'Email settings updated successfully.');
            }
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
    }

    initEmailTemplateConstants() {
        const self = this;

        self.emailTemplateTypes = [
            {id: self.EMAIL_TEMPLATE_EOI_SUBMITTED, name: "On EOI Submitted", recipients: ":: EOI BUYERS"},
            {id: self.EMAIL_TEMPLATE_SETTINGS_OTP_GENERATED, name: "On New OTP"},
            {id: self.EMAIL_TEMPLATE_SETTINGS_OTP_RE_GENERATED, name: "On Update Sale Details"},
            {id: self.EMAIL_TEMPLATE_SETTINGS_SPA_DATE_UPDATED, name: "On Update SPA Date"},
            {id: self.EMAIL_TEMPLATE_SETTING_SALE_ABORT, name: "On Option Abort"},
            {id: self.EMAIL_TEMPLATE_SETTING_ON_ADD_PAYMENT, name: "On Add Payment"},
            {id: self.EMAIL_TEMPLATE_SETTING_ON_ADD_PAYMENT_INSTRUMENT, name: "On Add Instrument"},
        ];
    }

    fillDefaultAllowedDocumentKinds(document_kinds_list) {
        let self = this;

        let recipients_list = ['buyer', 'buyer_lawyers', 'developer', 'developer_lawyers', 'agents', 'team_ic'];

        //try{
        //    self.psettings.default_allowed_document_kinds = JSON.parse(self.psettings.default_allowed_document_kinds);
        //}
        //catch (ex)
        //{
        //    self.psettings.default_allowed_document_kinds = {};
        //
        //}
        //console.log(self.psettings.default_allowed_document_kinds);
        //
        //self.default_allowed_document_kinds = {};

        recipients_list.forEach(function (recipient) {

            let default_allowed_document_kinds = [];

            document_kinds_list.forEach(function (document) {

                default_allowed_document_kinds.push({
                    "document_kind": document.document_kind,
                    "document_name": document.document_name,
                    "allowed": self.isDocumentKindAllowed(recipient, document.document_kind)
                });

            });

            self.psettings.default_sale_email_document_kinds[recipient] = default_allowed_document_kinds;

        });
    }

    isDocumentKindAllowed(recipient, documentKind) {

        const self = this;

        let default_allowed_document_kinds;
        try {
            default_allowed_document_kinds = JSON.parse(self.psettings["server_default_allowed_document_kinds"])
        } catch (ex) {
            default_allowed_document_kinds = {};
        }

        let recipient_default_allowed_document_kinds = default_allowed_document_kinds[recipient] || [];
        return recipient_default_allowed_document_kinds.includes(documentKind);

    }

    //end of the project settings

    /**
     * WEB-3540: Coerce every genuine map-type property-setting blob to a plain object ({}).
     *
     * @remarks
     * property_settings.value is persisted as a raw string (no JSON cast on the BE), so the shape the
     * FE serialises is exactly what is read back. An empty associative structure can be stored as []
     * (legacy data / PHP json_encode); on load each of these blobs is OVERWRITTEN by
     * JSON.parse(setting.value), so a stored "[]" becomes an in-memory array. The UI then dot-assigns
     * keys onto it (ng-model="...X.enable"), and JSON.stringify on save drops those keys (arrays only
     * serialise index elements) — silent data loss + a shape that flips between [] and {}.
     *
     * Only ARRAY values are coerced (NOT falsy). A falsy → {} coercion would be wrong here: the save
     * loop persists every blob whose typeof is not "undefined", so turning an absent (never-saved)
     * setting into {} would spuriously create empty "{}" rows. Extends the WEB-3538 / WEB-3406 fix.
     *
     * Excluded by design: aml (rebuilt fresh on save), payment_types* / default_sale_email_document_kinds
     * (genuine arrays / rebuilt), pp_form_required_fields* and buyer_identity_documents_disabled (maps,
     * but mutated in place so never overwritten with []), and all scalar settings.
     *
     * @returns {void} Mutates self.psettings in place.
     */
    normalizeMapPropertySettings() {
        const self = this;

        $.each(self.MAP_PROPERTY_SETTING_NAMES, function (index, name) {
            if (Array.isArray(self.psettings[name])) {
                self.psettings[name] = {};
            }
        });
    }

    //save the property settings
    savePropertySettings(optionalName) {
        const self = this;

        self.settingsError = {};
        if (self.psettings['different_otp_for_commercial_units'].enable
            && !self.isValidSettingsInput(self.psettings['different_otp_for_commercial_units'])) {
            return false;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (selectedOption) {

                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function (data) {
                        for (let index = 0; index < self.setting_names.length; ++index) {
                            if (typeof (self.psettings[self.setting_names[index]]) != "undefined") {

                                let name = self.setting_names[index];
                                let value = self.psettings[name];
                                if(optionalName && name != optionalName) {
                                    continue;
                                }

                                /** WEB-3540: final safety net — never serialise a genuine map setting as [] */
                                if (self.MAP_PROPERTY_SETTING_NAMES.indexOf(name) !== -1 && Array.isArray(value)) {
                                    value = {};
                                    self.psettings[name] = value;
                                }

                                if (name === "payment_types") {
                                    let filtered_values = value.filter(x => x.allowed == true);
                                    value = [];
                                    $.each(filtered_values, function (index, filtered_value) {
                                        value.push(filtered_value.id);
                                    });
                                    value = JSON.stringify(value);
                                }
                                if (name === "payment_types_eoi") {
                                    let filtered_values = value.filter(x => x.allowed == true);
                                    value = [];
                                    $.each(filtered_values, function (index, filtered_value) {
                                        value.push(filtered_value.id);
                                    });
                                    value = JSON.stringify(value);
                                }
                                if (name === "payment_types_dms") {
                                    let filtered_values = value.filter(x => x.allowed == true);
                                    value = [];
                                    $.each(filtered_values, function (index, filtered_value) {
                                        value.push(filtered_value.id);
                                    });
                                    value = JSON.stringify(value);
                                }
                                if (name === "default_sale_email_document_kinds") {
                                    value = self.getSelectedDefaultAllowedDocumentKinds(value);
                                }

                                if (name === 'aml_cft' && self.aml_cft_checkbox == false)
                                    value = '';

                                if (name === 'aml') {
                                    value = JSON.stringify({
                                        risk_assessment_required: value.risk_assessment_required ? 1 : 0
                                    });
                                }

                                if (name === 'arms_email' && self.arms_email_checkbox == false) {
                                    value = '';
                                }

                                if (name === self.PROPERTY_SETTINGS_REMOTE_SIGNING_REVERT
                                    || name === self.PROPERTY_SETTINGS_TEAM_IC_COUNTER_BOOKING
                                    || name === self.PROPERTY_SETTINGS_CORPORATE_PURCHASE_MULTIPLE_SIGNATORIES_SUPPORT
                                    || name === self.PROPERTY_SETTINGS_TRUE_PURCHASER_MULTIPLE_SIGNATORIES_SUPPORT
                                    || name === self.PROPERTY_SETTINGS_SEND_STATUS_AND_PRICE_UPDATES_TO_EXTERNAL_CLIENT
                                    || name === self.PROPERTY_SETTINGS_ENABLE_SHOWCASE
                                    || name === self.PROPERTY_SETTINGS_ENABLE_SHOWCASE_ANALYTICS
                                    || name === 'skip_team_ic_booking_verification'
                                    || name === 'skip_developer_sale_verification'
                                    || name === self.PROPERTY_SETTINGS_LONGER_UNIT_RESERVATION_NOTIFICATION
                                    || name === 'enquiry_email'
                                    || name === 'gst_setting'
                                    || name === 'unit_price_gst_inclusive'
                                    || name === 'pp_form_required_fields'
                                    || name === 'pp_form_required_fields_eoi'
                                    || name === 'pp_form_required_fields_non_buyer_payee'
                                    || name === 'pp_form_required_fields_power_of_attorney'
                                    || name === 'pp_form_required_fields_other_beneficiary_owner'
                                    || name === 'pp_form_required_fields_true_purchaser'
                                    || name === 'pp_form_required_fields_beneficiary'
                                    || name === 'non_buyer_payee_settings'
                                    || name === 'pp_form_required_fields_witness'
                                    || name === 'witness_settings'
                                    || name === 'power_of_attorney_settings'
                                    || name === 'other_beneficiary_owner_settings'
                                    || name === 'true_purchaser_settings'
                                    || name === 'other_aml_cft_settings'
                                    || name === 'sale_otp_representative_settings'
                                    || name === self.PROPERTY_SETTINGS_ALLOW_UNIT_ALLOCATION_FOR_SUBMITTED_EOIS
                                    || name === self.PROPERTY_SETTINGS_ENABLE_SINGAPORE_NRIC_VALIDATION
                                ) {
                                    value = JSON.stringify(value);
                                }

                                if (name === 'buyer_identity_documents_disabled') {
                                    $.each(value, function (k, v) {
                                        value[k] = v ? 1 : 0;
                                    });
                                    value = JSON.stringify(value);
                                }

                                if (name === 'different_otp_for_commercial_units') {
                                    if (!value.enable) {
                                        value.prefix = "";
                                        value.postfix = "";
                                        value.starting_no = null;
                                    }

                                    value = JSON.stringify(value);
                                }
                                // WEB-3614 — Subsale Draft → Approved flow toggle ({enable:bool})
                                if (name === 'subsale_approval_flow') {
                                    value = JSON.stringify(value);
                                }
                                /**
                                 * WEB-3908 — Billing Date follows Notice Served Date ({enabled:0|1}).
                                 * Persisted with a numeric 0/1 (not a boolean) so the stored blob is
                                 * byte-identical to the shape PaymentService reads on the server.
                                 * Serialised unconditionally: the OFF value must be written as an
                                 * explicit {"enabled":0} rather than deleted, so switching the setting
                                 * back off is an actual save and not a silent no-op.
                                 */
                                if (name === 'billing_date_follows_notice_served_date') {
                                    value = JSON.stringify({
                                        enabled: value && value.enabled ? 1 : 0
                                    });
                                }
                                if (name == self.PROPERTY_SETTINGS_TOP_MAINTENANCE_AND_SURVEY_FEE) {
                                    value = JSON.stringify(value);
                                }

                                /**
                                 * WEB-4250 — a falsy value is a VALUE, not an instruction to delete
                                 * the row.
                                 *
                                 * This used to read `if (value) save; else delete;`. Because 0 and ""
                                 * are falsy, pressing Save DELETED the property_settings row of every
                                 * setting that legitimately stores one — Buying In Trust = No (0),
                                 * Minimum Age = None (0), a 0-day Buyer Sale Documents link expiry, a
                                 * blank Agent Booking Declaration, an un-ticked AML/CFT or ARMS email —
                                 * even when the user changed nothing. Six rows vanished on the first
                                 * save of every project, one project at a time.
                                 *
                                 * The rules now:
                                 *  - undefined / null  the screen holds nothing for this setting, so
                                 *                      leave whatever is stored alone.
                                 *  - ""                the API rejects a blank value (the `value`
                                 *                      field is `required`), so blank can only be
                                 *                      expressed as the ABSENCE of the row. Delete —
                                 *                      but only when the user actually cleared a value
                                 *                      that was there, never when it was already blank.
                                 *  - anything else     save it, 0 included.
                                 */
                                if (value === undefined || value === null) {
                                    continue;
                                }

                                if (value === '') {
                                    if (!self._isStoredSettingBlank(name)) {
                                        self._deletePropertySetting(name);
                                    }
                                    continue;
                                }

                                self._savePropertySetting(name, value);
                            }
                        }

                    }
                );
            }
        );
    }

    isValidSettingsInput(params) {
        const self = this;

        let isValid = true;

        if (params.prefix && params.prefix.length > 3) {
            isValid = false;
            self.settingsError.prefix = "Only 3 maximum characters are allowed";
        }
        if (params.postfix && params.postfix.length > 3) {
            isValid = false;
            self.settingsError.postfix = "Only 3 maximum characters are allowed";
        }
        if (params.starting_no && params.starting_no < 0) {
            isValid = false;
            self.settingsError.starting_no = "Please enter starting number greater than zero";
        }

        return isValid;
    }

    getSelectedDefaultAllowedDocumentKinds(documentsObject) {

        let recipients_list = ['buyer', 'buyer_lawyers', 'developer', 'developer_lawyers', 'agents', 'team_ic'];


        let recipients_allowed_documents_kinds = {
            'buyer': [],
            'buyer_lawyers': [],
            'developer': [],
            'developer_lawyers': [],
            'agents': [],
            'team_ic': []
        };

        recipients_list.forEach(function (recipient) {

            let recipientDocuments = documentsObject[recipient];

            recipientDocuments.forEach(function (document) {

                if (document.allowed) {
                    recipients_allowed_documents_kinds[recipient].push(document.document_kind);
                }
            });


        });

        console.log("recipients_allowed_documents:" + recipients_allowed_documents_kinds);
        return JSON.stringify(recipients_allowed_documents_kinds);

    }

    //end  of the save property settings

    /**
     * WEB-4250: whether this setting is already blank as far as the server is concerned — either
     * it has no property_settings row at all, or the row it has holds an empty value. Saving a
     * blank over one of these would be a no-op, so the save loop skips it instead of issuing a
     * delete that destroys the row.
     *
     * @param {string} name property setting name
     * @returns {boolean}
     */
    _isStoredSettingBlank(name) {
        const self = this;

        const stored = self.storedSettingValues ? self.storedSettingValues[name] : undefined;

        return stored === undefined || stored === null || stored === '';
    }

    _savePropertySetting(name, value) {
        const self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/settings';
        let params = {
            name: name,
            value: value,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Project setting updated successfully.");
            self.topSettingsEditMode = false;
            let propertySetting = response.data.property_setting;
            let alreadyExists = false;

            jQuery.each(self.data.property.settings, function (i, e) {
                if (e.name == name) {
                    angular.merge(e, propertySetting);
                    alreadyExists = true;
                    return false;
                }
            });

            if (!alreadyExists) {
                self.data.property.settings.push(propertySetting);
            }

            // WEB-4250: keep the snapshot current so a later save in the same page session can still
            // tell "the user just cleared this" from "it was already blank".
            self.storedSettingValues[name] = propertySetting ? propertySetting.value : value;
        });
    }

    _deletePropertySetting(name) {
        const self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/settings/' + name + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Project setting updated successfully.");

            jQuery.each(self.data.property.settings, function (i, e) {
                if (e.name == name) {
                    self.data.property.settings.splice(i, 1);
                    return false;
                }
            });

            // WEB-4250: the row is gone, so a repeat save must not try to delete it again.
            delete self.storedSettingValues[name];
        });
    }

    // ----- WEB-3631: project-level document-numbering overrides (Invoice / Receipt / Credit Note) -----

    /**
     * Load the effective document-numbering settings for this project.
     * Per series the server returns the resolved source (project|developer|none), the project override
     * value (if any), the developer default value (if any) and a side-effect-free next-number preview.
     */
    getTrackingNumberSettings() {
        const self = this;

        if (!self.data.property || !self.data.property.id) {
            return;
        }

        let url = 'sec/developer/properties/' + self.data.property.id + '/tracking-number-settings';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.trackingNumberSettings = response.data.tracking_number_settings || {};

            [
                self.DEVELOPER_SETTINGS_PAYMENT_TRACKING_NUMBER,
                self.DEVELOPER_SETTINGS_INSTRUMENT_TRACKING_NUMBER,
                self.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER,
            ].forEach(function (name) {
                self.initTrackingForm(name);
            });
        });
    }

    /**
     * Reset the edit buffer for a series from the loaded settings.
     * Prefills from the project override when present, otherwise from the developer default as a starting template.
     *
     * @param {string} name payment_tracking_no | instrument_tracking_no | refund_payment_tracking_no
     */
    initTrackingForm(name) {
        const self = this;

        let setting = (self.trackingNumberSettings && self.trackingNumberSettings[name]) || {};
        let source = setting.has_project_override ? setting.project_value : setting.developer_value;
        let value = angular.copy(source || {});

        // A fresh project override starts its own counter — don't inherit the developer's last-generated number.
        if (!setting.has_project_override && name === self.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER) {
            delete value.refund_payment_last_generated_tracking_no;
        }

        self.trackingForm[name] = {
            override: !!setting.has_project_override,
            value: value,
        };
        self.trackingEditMode[name] = false;
    }

    /**
     * Toggle edit mode for a numbering series (resets the buffer when entering edit mode).
     * Only one series is open for editing at a time.
     *
     * @param {string} name
     * @param {boolean} editMode
     */
    editTrackingSetting(name, editMode) {
        const self = this;

        self.trackingError = {};

        if (editMode) {
            self.initTrackingForm(name);
        }

        self.trackingEditMode = {
            payment_tracking_no: false,
            instrument_tracking_no: false,
            refund_payment_tracking_no: false,
        };
        self.trackingEditMode[name] = editMode;
    }

    /**
     * Mirror the developer-level rule: length is required for Invoice/Receipt when overriding
     * (Credit Note may be left blank — WEB-2826). Turning the override OFF deletes the setting,
     * so there is nothing to validate.
     *
     * @param {string} name
     * @returns {boolean}
     */
    isValidTrackingInput(name) {
        const self = this;

        self.trackingError = {};

        let form = self.trackingForm[name];

        if (!form || !form.override) {
            return true;
        }

        if (name !== self.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER) {
            if (!form.value[name + '_length']) {
                self.trackingError[name + '_length'] = 'Length field is required.';
                return false;
            }
        }

        return true;
    }

    /**
     * Save a numbering series for the project.
     * Override ON  → POST the project setting (JSON value) via the generic project-settings endpoint.
     * Override OFF → DELETE the project setting, reverting to the developer-level default.
     *
     * The generic project-settings endpoint is 2FA-gated (a direct POST/DELETE returns 401 sub_code
     * 401002 "2FA session has expired"), so — exactly like savePropertySettings — the mutation runs
     * inside a confirmation + OTPService.getVerified(TYPE_SESSION_2FA) step-up that pops the OTP modal.
     *
     * @param {string} name
     */
    saveTrackingSetting(name) {
        const self = this;

        if (!self.isValidTrackingInput(name)) {
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (selectedOption) {

                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function (data) {
                        let form = self.trackingForm[name];

                        if (form && form.override) {
                            let value;
                            try {
                                value = JSON.stringify(form.value);
                            } catch (ex) {
                                console.log(ex);
                                return;
                            }
                            self._saveTrackingSetting(name, value);
                        } else {
                            self._deleteTrackingSetting(name);
                        }
                    }
                );
            }
        );
    }

    /**
     * POST the project numbering override, then refresh the preview / source.
     *
     * @param {string} name
     * @param {string} value JSON string
     */
    _saveTrackingSetting(name, value) {
        const self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/settings';
        let params = {
            name: name,
            value: value,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Project setting updated successfully.');
            self.trackingEditMode[name] = false;
            self.getTrackingNumberSettings();
        });
    }

    /**
     * DELETE the project numbering override (revert to developer default), then refresh the preview / source.
     *
     * @param {string} name
     */
    _deleteTrackingSetting(name) {
        const self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/settings/' + name + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Project setting updated successfully.');
            self.trackingEditMode[name] = false;
            self.getTrackingNumberSettings();
        });
    }

    processPaymentTypes(setting) {
        const self = this;
        $.each(self.psettings.payment_types, function (index, paymentType) {
            if (paymentType.id == setting) {
                paymentType.allowed = true;
                if (paymentType.id === -1) {
                    self.paymentTypesDisabled = true;
                }
            }
        })
    }

    processPaymentTypesEoi(setting) {
        const self = this;
        $.each(self.psettings.payment_types_eoi, function (index, paymentType) {
            if (paymentType.id == setting) {
                paymentType.allowed = true;
                if (paymentType.id === -1) {
                    self.paymentTypesEoiDisabled = true;
                }
            }
        });
    }

    processPaymentTypesDMS(setting) {
        const self = this;
        $.each(self.psettings.payment_types_dms, function (index, paymentType) {
            if (paymentType.id == setting) {
                paymentType.allowed = true;
                if (paymentType.id === -1) {
                    self.paymentTypesDMSDisabled = true;
                }
            }
        })
    }

    paymentTypesDisabledClicked() {
        const self = this;

        self.paymentTypesDisabled = !(self.paymentTypesDisabled);

        $.each(self.psettings.payment_types, function (index, paymentType) {
            if (paymentType.id === -1) {
                paymentType.allowed = self.paymentTypesDisabled;
            } else if (self.paymentTypesDisabled) {
                paymentType.allowed = false;
            }
        });
    }

    paymentTypesEoiDisabledClicked(type) {
        const self = this;

        self.paymentTypesEoiDisabled = !(self.paymentTypesEoiDisabled);

        $.each(self.psettings.payment_types_eoi, function (index, paymentType) {
            if (paymentType.id === -1) {
                paymentType.allowed = self.paymentTypesEoiDisabled;
            } else if (self.paymentTypesEoiDisabled) {
                paymentType.allowed = false;
            }
        });
    }

    paymentTypesDMSDisabledClicked(type) {
        const self = this;

        self.paymentTypesDMSDisabled = !(self.paymentTypesDMSDisabled);

        $.each(self.psettings.payment_types_dms, function (index, paymentType) {
            if (paymentType.id === -1) {
                paymentType.allowed = self.paymentTypesDMSDisabled;
            } else if (self.paymentTypesDMSDisabled) {
                paymentType.allowed = false;
            }
        });
    }

    exportUnitsForSurveyFee(){
        const self = this;
        let exportUrl = 'sec/developer/properties/' + self.data.property.id + '/units/export-survey-fees';

        let url = self.SSHttpService.getApiURL(exportUrl);
        console.log(url);
        self.$window.location.href  = url;
    }

    // Units Survey Fee Import
    uploadUnitsForSurveyFee(file){
        const self = this;

        if(!file){
            return;
        }

        let url = self.SSHttpService.getApiURL('sec/developer/properties/' + self.property.id + '/units/import-survey-fees');

        loading(true);
        self.Upload.upload({
            url: url,
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Success!", "Survey Fee imported successfully");
            self.getUnitSchedule();

        }, function (response) {
            loading(false);

            self.SSAlertService.parseAndDisplayError(response);
        });
    }

    getNameOfReportAttachment(reportId) {
        const self = this;
        if (reportId && self.developerReports) {
            const report = self.developerReports.find(function (_report) {
                return _report.report_id == reportId;
            });
            if (report) {
                return report.alias;
            }
        }
        return "--";
    }
    getSpecificPPFormFields(fields, key){
        const filteredFields = {};
        if(key === 'individual'){
            for (const key in fields) {
                if (fields.hasOwnProperty(key)) {
                    if (!key.startsWith('company_') &&
                            !key.startsWith('signatory_') &&
                            !key.startsWith('key_personnel') &&
                            !key.startsWith('legal_entity') &&
                            !key.includes('address')) {
                        filteredFields[key] = fields[key];
                    }
                }
            }
        }else if(key === 'company'){
            for (const key in fields) {
                if (fields.hasOwnProperty(key)) {
                    if (key.startsWith('company_')) {
                        filteredFields[key] = fields[key];
                    }
                }
            }
        }else if(key === 'signatory'){
            for (const key in fields) {
                if (fields.hasOwnProperty(key)) {
                    if (key.startsWith('signatory_')) {
                        filteredFields[key] = fields[key];
                    }
                }
            }
        }else if(key === 'key_personnel'){
            for (const key in fields) {
                if (fields.hasOwnProperty(key)) {
                    if (key.startsWith('key_personnel_')) {
                        filteredFields[key] = fields[key];
                    }
                }
            }
        }else if(key === 'legal_entity'){
            for (const key in fields) {
                if (fields.hasOwnProperty(key)) {
                    if (key.startsWith('legal_entity_')) {
                        filteredFields[key] = fields[key];
                    }
                }
            }
        }else if(key === 'address'){
            for (const key in fields) {
                if (fields.hasOwnProperty(key)) {
                    if (key.includes('address')) {
                        filteredFields[key] = fields[key];
                    }
                }
            }
        }
        return filteredFields;

    }

    changeValueForIdentityDocumentBuyers(key){
        let self = this;
        if(key === 'buyer_individual_booking'){
            self.psettings.buyer_identity_documents_disabled.buyers = self.psettings.buyer_identity_documents_disabled.buyer_individual_booking;
        }
    }

    changeValueForIdentityDocumentNonBuyerPayee(key) {
        let self = this;

        self.psettings.buyer_identity_documents_disabled.non_buyers_payees =
                self.psettings.buyer_identity_documents_disabled.non_buyers_payees_individual ||
                self.psettings.buyer_identity_documents_disabled.non_buyers_payees_company ||
                self.psettings.buyer_identity_documents_disabled.non_buyers_payees_signatory ||
                self.psettings.buyer_identity_documents_disabled.non_buyers_payees_key_personnel;
    }

    exportProjectSettings(propertyId){
        const self = this;
        let url = "sec/developer/properties/"+propertyId+"/settings/export";
        url = self.SSHttpService.getApiURL(url);
        self.SSAlertService.success('Success!', 'Project setting export successfully.');
        window.open(url, '_blank');
    }

    openModalImpProjSet(){
        const self = this;
        self.importProjectSettingFile = null;
        $('#importProjectSettingsModal').modal('show');
    }

    importProjectSettings(){
        const self = this;
        let propertyId = self.data.property.id;
        if (!self.importProjectSettingFile) {
            self.SSAlertService.warning('Please select file to import.');
            return;
        }
        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/properties/'+propertyId+'/settings/import'),
            method: 'POST',
            data: {
                file: self.importProjectSettingFile
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);
            if (response && response.data && response.data.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Project setting import successfully.');
            self.importProjectSettingFile = null;
            $('#importProjectSettingsModal').modal('hide');
            self.init();
        }, function (response) {
            loading(false);
            self.SSAlertService.parseAndDisplayError(response);
        }, function (evt) {
        });
    }

}

PropertySettingsController.$inject = ['$sce', '$scope', '$parse', '$window', '$timeout','$localStorage', 'SSHttpService', 'SSUtilService', 'SSConfigService', 'SSAppService', 'SSAlertService', 'OTPService', 'NgTableParams', 'SSConfirmationService', 'SSUserService', 'Upload'];
app.controller('PropertySettingsController', PropertySettingsController);